(function () {
  if (window.LpNovaCapsulasTrilho) return;
  window.LpNovaCapsulasTrilho = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function passo(scroller) {
    var card = scroller.querySelector("[data-lp-card]");
    return card ? card.getBoundingClientRect().width + 16 : 300;
  }

  function init(root) {
    if (!root || root.dataset.lpTrilhoReady === "true") return;
    var scroller = root.querySelector("[data-lp-trilho]");
    if (!scroller) return;
    root.dataset.lpTrilhoReady = "true";

    root.querySelectorAll("[data-lp-trilho-dir]").forEach(function (button) {
      button.addEventListener("click", function () {
        var direction = button.getAttribute("data-lp-trilho-dir") === "prev" ? -1 : 1;
        scroller.scrollBy({ left: direction * passo(scroller), behavior: reduce ? "auto" : "smooth" });
      });
    });

    var arrastando = false;
    var arrastou = false;
    var origem = 0;
    var rolagem = 0;

    scroller.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      if (event.target.closest("button, input")) return;
      arrastando = true;
      arrastou = false;
      origem = event.clientX;
      rolagem = scroller.scrollLeft;
    });

    scroller.addEventListener("pointermove", function (event) {
      if (!arrastando) return;
      var delta = event.clientX - origem;
      if (!arrastou && Math.abs(delta) < 6) return;
      if (!arrastou) {
        arrastou = true;
        scroller.classList.add("lp-nova-capsulas-arrastando");
        scroller.setPointerCapture(event.pointerId);
      }
      scroller.scrollLeft = rolagem - delta;
    });

    function solta() {
      if (!arrastando) return;
      arrastando = false;
      scroller.classList.remove("lp-nova-capsulas-arrastando");
    }

    scroller.addEventListener("pointerup", solta);
    scroller.addEventListener("pointercancel", solta);

    scroller.addEventListener("click", function (event) {
      if (!arrastou) return;
      arrastou = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    scroller.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      var direction = event.key === "ArrowLeft" ? -1 : 1;
      scroller.scrollBy({ left: direction * passo(scroller), behavior: reduce ? "auto" : "smooth" });
    });
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll("[data-lp-trilho-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
